import { useMemo } from 'react'
import { Repeat } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useFilterValueCounts } from '../useFilterValueCounts'
import { MultiSelectCommandList } from './MultiSelectCommandList'
import type { ValuePickerProps } from './types'
import { useCycles } from '@/lib/db/rxdb/hooks/entities/cycles'

export function CycleFilterPicker({
  selectedValues,
  onToggleValue,
}: ValuePickerProps) {
  const { t } = useTranslation('tasks')
  const counts = useFilterValueCounts('cycle')
  const { cycles } = useCycles()

  const options = useMemo(
    () =>
      (cycles ?? [])
        .filter((c) => !c.isDeleted)
        .sort((a, b) => b.number - a.number)
        .map((c) => ({
          value: c.id,
          label: c.name,
          icon: <Repeat className="size-3.5 text-muted-foreground" />,
        })),
    [cycles],
  )

  return (
    <MultiSelectCommandList
      options={options}
      selectedValues={selectedValues}
      onToggle={onToggleValue}
      searchPlaceholder={t('filters.search.cycles')}
      counts={counts}
    />
  )
}
